module.exports = "/assets/bad45dc3735bd49b44b469761ed31534.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/4U.png
// module id = 2176
// module chunks = 0